import { ApiParameter, post, request } from "@insite/client-framework/Services/ApiService";
import { QuoteItems } from "@tJohnstonCompanies/Handlers/RfqQuote/RfqQuoteNewState";

export interface QuoteModel {
    CustomerOrderId?: string;
    QuoteCustomProductsList?: QuoteItems[];
}

const quoteUrl = "api/v2/quotecustomproducts/RequestForQuote";

export async function addQuoteDataFields(parameter: QuoteModel) {
    try {
        const headers = {
            "Content-Type": "application/json", // Set the Content-Type header to JSON
        };
        const response = await request<QuoteModel>(quoteUrl, "POST", headers, JSON.stringify(parameter));
        return response;
    } catch (error) {
        console.log("Error adding quote fields:", error);
        throw new Error("Failed to add quotefields");
    }
}
